import { QrcodeIcon, TagIcon, TicketIcon } from "@heroicons/react/outline";
import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { Activity } from "components/customIcons";
import { DescriptionItem } from "components/descriptionItem";
import { FullScreenLoading } from "components/fullScreenLoading";
import { HistoryLogButton } from "components/historyLogButton";
import { IAttractionQRCodeDetail } from "interfaces";

export const AttractionQRCodeDetail: React.FC = () => {
    const parse = useParse();
    const { params } = parse();
    const {
      data,
      isFetching,
      isPreviousData,
      isLoading,
    } = useOne<IAttractionQRCodeDetail>({
      resource: "participant/ecodes",
      id: params?.id,
      meta: {
        resource: "data",
      },
      queryOptions: {
        enabled: !!params?.id,
      } as any,
    });
  
    const attractionQRCodeDetailData = data?.data ?? null;
  
    if (isLoading) {
      return <FullScreenLoading />
    }
  
    return (
      <div className="w-full flex flex-col items-center gap-y-3 sm:gap-y-4">
        <Breadcrumbs
          customPageLabel="Code Detail"
          additionalLabel={
            <div>
              <HistoryLogButton
                resource={`participant/ecodes/${attractionQRCodeDetailData?.id}/history`}
              />
            </div>
          }
        />
        <div className="box-container p-0">
          <div className="divide-y divide-gray-100">
            <DescriptionItem
              icon={TagIcon}
              label="Status"
              content={
                <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                  {attractionQRCodeDetailData?.is_active ? "Active" : "Inactive"}
                </p>
              }
            />
            <DescriptionItem
              icon={QrcodeIcon}
              label="Code"
              content={
                <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                  {attractionQRCodeDetailData?.code}
                </p>
              }
            />
            <DescriptionItem
              icon={Activity}
              iconFillColor={"#f1600d"}
              label="Event name"
              content={
                <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                  {attractionQRCodeDetailData?.event?.name_en}
                </p>
              }
            />
            <DescriptionItem
              icon={TicketIcon}
              label="Ticket name"
              content={
                <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                  {attractionQRCodeDetailData?.ticket?.name_en}
                </p>
              }
            />
          </div>
        </div>
        {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
      </div>
    );
  }